import React, { Component } from "react";
import BottomNavigation from "reactjs-bottom-navigation";
import "reactjs-bottom-navigation/dist/index.css";
import {
  HomeOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  ShopOutlined,
  MoreOutlined,
  CloseOutlined,
  FacebookFilled,
  InstagramOutlined,
  TwitterOutlined,
  YoutubeOutlined,
  LinkedinOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import { Row, Col, Button, Drawer } from "antd";

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableMoreOptions: false,
      enableHomeOptions: false,
    };
  }

  onClickMenu = (menu) => {
    window.location.replace(menu);
  };

  render() {
    const { enableMoreOptions, enableHomeOptions } = this.state;

    const bottomNavItems = [
      {
        title: "Homes",
        icon: <HomeOutlined style={{ fontSize: "24px", cursor: "pointer" }} />,
        activeIcon: (
          <HomeOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.setState({ enableHomeOptions: true }),
      },
      {
        title: "Sellers",
        icon: <TeamOutlined style={{ fontSize: "24px", cursor: "pointer" }} />,
        activeIcon: (
          <TeamOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.onClickMenu("/buyers"),
      },
      {
        title: "Agents",
        icon: (
          <UserSwitchOutlined style={{ fontSize: "24px", cursor: "pointer" }} />
        ),
        activeIcon: (
          <UserSwitchOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.onClickMenu("/agent"),
      },
      {
        title: "Lenders",
        icon: (
          <DollarCircleOutlined
            style={{ fontSize: "24px", cursor: "pointer" }}
          />
        ),
        activeIcon: (
          <DollarCircleOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.onClickMenu("/lenders"),
      },
      {
        title: "Market",
        icon: <ShopOutlined style={{ fontSize: "24px", cursor: "pointer" }} />,
        activeIcon: (
          <ShopOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.onClickMenu("/marketplace"),
      },
      {
        title: "More",
        icon: <MoreOutlined style={{ fontSize: "24px", cursor: "pointer" }} />,
        activeIcon: (
          <MoreOutlined
            style={{ fontSize: "24px", color: "#fff", cursor: "pointer" }}
          />
        ),
        onClick: () => this.setState({ enableMoreOptions: true }),
      },
    ];

    return (
      <div>
        {/* Homes Drawer */}
        <Drawer
          title={null}
          placement="bottom"
          height={120}
          closable={false}
          getContainer={false}
          onClose={() => this.setState({ enableHomeOptions: false })}
          visible={enableHomeOptions}
          bodyStyle={{ paddingBottom: 100 }}
        >
          <Row
            align="middle"
            justify="space-between"
            style={{ padding: "10px", borderBottom: "1px solid #ccc" }}
          >
            <div>
              <h4>Homes</h4>
            </div>
            <div
              onClick={() => this.setState({ enableHomeOptions: false })}
              style={{ cursor: "pointer" }}
            >
              <CloseOutlined style={{ fontSize: "18px" }} />
            </div>
          </Row>

          <Col span={24} style={{ margin: "10px" }}>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <Button
                  style={{
                    backgroundColor:
                      window.location.pathname === "/homes" ? "#3045D2" : "#FFF",
                    color:
                      window.location.pathname === "/homes" ? "#FFF" : "#3045D2",
                    width: "100%",
                  }}
                  onClick={() => this.onClickMenu("/homes")}
                >
                  MLS Listed Homes
                </Button>
              </Col>

              <Col span={12}>
                <Button
                  style={{
                    backgroundColor:
                      window.location.pathname === "/offMLSHomes"
                        ? "#3045D2"
                        : "#FFF",
                    color:
                      window.location.pathname === "/offMLSHomes"
                        ? "#FFF"
                        : "#3045D2",
                    width: "100%",
                  }}
                  onClick={() => this.onClickMenu("/offMLSHomes")}
                >
                  Off MLS Homes
                </Button>
              </Col>
            </Row>
          </Col>
        </Drawer>

        {/* More Options Drawer */}
        {/* More Options Drawer - FIXED VERSION */}
        <Drawer
          title={null}
          placement="bottom"
          height={240}                    // Increased height to prevent overlapping
          closable={false}
          getContainer={false}
          onClose={() => this.setState({ enableMoreOptions: false })}
          visible={enableMoreOptions}
          bodyStyle={{ paddingBottom: 100 }}
        >
          <Row
            align="middle"
            justify="space-between"
            style={{ padding: "10px", borderBottom: "1px solid #ccc" }}
          >
            <div>
              <h4>Quick Menu</h4>
            </div>
            <div
              onClick={() => this.setState({ enableMoreOptions: false })}
              style={{ cursor: "pointer" }}
            >
              <CloseOutlined style={{ fontSize: "18px" }} />
            </div>
          </Row>

          <Col span={24} style={{ margin: "12px 10px" }}>
            <Row gutter={[12, 12]}>
              <Col span={12}>
                <Button
                  style={{
                    // backgroundColor: "#3045D2",
                    color: "#3045D2",
                    width: "100%",
                  }}
                  onClick={() => window.open("https://go.myhomebuddha.com/aboutus", "_blank")}
                >
                  About Us
                </Button>
              </Col>

              <Col span={12}>
                <Button
                  style={{
                    backgroundColor: "#3045D2",
                    color: "#fff",
                    fontWeight: "700",
                    width: "100%",
                  }}
                  onClick={() => {
                    const base = 'https://ai.myhomebuddha.com?mode=buyer';
                    const userLogin = localStorage.getItem('userLogin');
                    if (userLogin) {
                      const { Auth } = require('aws-amplify');
                      Auth.currentSession()
                        .then((session) => {
                          const token = session.getIdToken().getJwtToken();
                          window.open(`${base}&token=${encodeURIComponent(token)}`, '_blank');
                        })
                        .catch(() => window.open(base, '_blank'));
                    } else {
                      window.open(base, '_blank');
                    }
                  }}
                >
                  AI Tools &#127968;
                </Button>
              </Col>

              <Col span={12}>
                <Button
                  style={{
                    backgroundColor: window.location.pathname === "/contactUs" ? "#3045D2" : "#FFF",
                    color: window.location.pathname === "/contactUs" ? "#FFF" : "#3045D2",
                    width: "100%",
                  }}
                  onClick={() => this.onClickMenu("/contactUs")}
                >
                  Contact Us
                </Button>
              </Col>

              <Col span={12}>
                <Button
                  style={{
                    // backgroundColor: "#3045D2",
                    color: "#3045D2",
                    width: "100%",
                  }}
                  onClick={() => window.open("https://go.myhomebuddha.com/", "_blank")}
                >
                  Learn More
                </Button>
              </Col>
            </Row>
          </Col>

          {/* <Row justify="space-around">
            <Col
              span={8}
              style={{
                padding: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#3045D2",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                <Row justify="center">
                  <PhoneOutlined
                    style={{
                      color: "#3045d2",
                      fontWeight: "bold",
                      transform: "rotate(100deg)",
                      cursor: "pointer",
                    }}
                  />
                </Row>
                <Row justify="center">
                  <span
                    style={{
                      color: "#3045d2",
                      fontWeight: "bold",
                      marginTop: "5px",
                    }}
                  >
                    Phone
                  </span>
                </Row>
              </div>
            </Col>

            <Col
              span={8}
              style={{
                padding: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                <a
                  target="_blank"
                  href={"mailto:trbarber10@msn.com"}
                  style={{ textDecoration: "none" }}
                >
                  <Row justify="center">
                    <MailOutlined
                      style={{
                        color: "#3045d2",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    />
                  </Row>
                  <Row justify="center">
                    <span
                      style={{
                        color: "#3045d2",
                        fontWeight: "bold",
                        marginTop: "5px",
                      }}
                    >
                      E-Mail
                    </span>
                  </Row>
                </a>
              </div>
            </Col>

            <Col
              span={8}
              style={{
                padding: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                <Row justify="center">
                  <EnvironmentOutlined
                    style={{
                      color: "#3045d2",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  />
                </Row>
                <Row justify="center">
                  <span
                    style={{
                      color: "#3045d2",
                      fontWeight: "bold",
                      marginTop: "5px",
                    }}
                  >
                    Location
                  </span>
                </Row>
              </div>
            </Col>
          </Row> */}

          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: "15px 20px 10px",
              backgroundColor: "#fff",
              borderTop: "1px solid #eee",
            }}
          >
            <Row justify="space-around" align="middle" gutter={[20, 0]}>
              <Col>
                <a
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=61557396586017"
                  rel="noreferrer"
                >
                  <FacebookFilled style={{ color: "#2a2a2a", fontSize: "26px" }} />
                </a>
              </Col>
              <Col>
                <a
                  target="_blank"
                  href="https://www.instagram.com/my_home_buddha/"
                  rel="noreferrer"
                >
                  <InstagramOutlined style={{ color: "#2a2a2a", fontSize: "26px" }} />
                </a>
              </Col>
              <Col>
                <a
                  target="_blank"
                  href="https://twitter.com/thatsmytown"
                  rel="noreferrer"
                >
                  <TwitterOutlined style={{ color: "#2a2a2a", fontSize: "26px" }} />
                </a>
              </Col>
              <Col>
                <a
                  target="_blank"
                  href="https://www.youtube.com/@MyHomeBuddha"
                  rel="noreferrer"
                >
                  <YoutubeOutlined style={{ color: "#2a2a2a", fontSize: "26px" }} />
                </a>
              </Col>
              <Col>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/home-buddha"
                  rel="noreferrer"
                >
                  <LinkedinOutlined style={{ color: "#2a2a2a", fontSize: "26px" }} />
                </a>
              </Col>
            </Row>

            <Row justify="center" style={{ marginTop: "15px" }}>
              <span
                style={{
                  color: "#2a2a2a",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                © Copyright My Home Buddha
              </span>
            </Row>
          </div>
        </Drawer>

        {/* Bottom Navigation */}
        <style>{`
          .rbn { background-color: #3045D2 !important; }
          .rbn-item span { color: rgba(255,255,255,0.7) !important; }
          .rbn-item--active span { color: white !important; }
        `}</style>
        <BottomNavigation
          items={bottomNavItems}
          defaultSelected={
            window.location.pathname === "/homes" ||
              window.location.pathname === "/offMLSHomes"
              ? 0
              : window.location.pathname === "/buyers"
                ? 1
                : window.location.pathname === "/agent"
                  ? 2
                  : window.location.pathname === "/lenders"
                    ? 3
                    : window.location.pathname === "/marketplace"
                      ? 4
                      : window.location.pathname === "/about" ||
                        window.location.pathname === "/whyJoinUs" ||
                        window.location.pathname === "/contactUs"
                        ? 5
                        : null
          }
          color="#fff"
          activeBgColor="#3045D2"
          onItemClick={(item) => console.log(item)}
        />
      </div>
    );
  }
}